import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { ContactTemplate } from '../../../types/ContactTemplate';

export const fetchContactTemplate = async (uuid: string | undefined) => {
  if (!uuid) return null;

  const response = await CustomAxios.get<ContactTemplate>(`contact_templates/${uuid}`);
  return response.data;
};

interface UseGetContactTemplateByIdProps {
  uuid?: string;
}

export function useGetContactTemplateById({ uuid }: UseGetContactTemplateByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allContactTemplates, uuid],
    queryFn: () => fetchContactTemplate(uuid),
  });
}
